<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <span
          class="btn btn-outline-primary btn-sm mr-2 mb-2"
          v-if="job.job_status_location"
          ><i class="lni lni-stamp"></i>
          {{ job.job_status_location.status }}</span
        >
        <span
          class="btn btn-outline-secondary btn-sm mb-2"
          v-if="job.job_status_location"
        >
          <i class="lni lni-map-marker"></i>
          {{ job.job_status_location.location }}</span
        >
        <span
          class="btn btn-danger btn-sm mb-2"
          v-if="job.was_previosuly_repaired"
        >
          Repeat</span
        >
        <span class="btn btn-info float-right btn-sm">
          {{
            moment
              .duration(job.tat_seconds, "seconds")
              .format("D [day], H [hour &] m [min]")
          }}
        </span>

        <b-tabs v-model="tabIndex">
          <b-tab title="Details">
            <table class="table">
              <table-row label="Outcome" :noBorder="true">
                <span class="font-weight-bold text-primary">
                  {{ job.outcome }}</span
                >
              </table-row>
              <table-row label="Number" :copyText="job.job_number">
                {{ job.job_number }}
              </table-row>

              <table-row label="Manufacture" v-if="job.manufacture">
                {{ job.manufacture.description }}
              </table-row>

              <table-row label="Type" v-if="job.device_type">
                {{ job.device_type.description }}
              </table-row>

              <table-row label="Model" v-if="job.device_model">
                {{ job.device_model.description }}
              </table-row>

              <table-row label="Pass Code" v-if="job.pass_code">
                {{ job.pass_code }}
              </table-row>

              <table-row label="Pattern Sequence" v-if="job.pattern_sequence">
                {{ job.pattern_sequence }}<br />
                <img src="@/assets/img/pattern_number.png" />
              </table-row>

               <table-row label="Warranty">
                <i
                  class="lni lni-checkmark-circle text-success"
                  v-if="job.is_in_warranty"
                ></i>
                  <span v-if="job.is_warranty_voided == 1" class="m-0 text-danger">
                    WARRANTY VOIDED
                  </span>
              </table-row>

              <table-row
                label="IMEI"
                v-if="job.imei_in"
                :copyText="job.imei_in"
              >
                {{ job.imei_in }}
              </table-row>

               <table-row
                label="IMEI Out(replacement)"
                v-if="job.imei_out"
                :copyText="job.imei_out"
              >
                {{ job.imei_out }}
              </table-row>

              <table-row
                label="Serial"
                v-if="job.serial_in"
                :copyText="job.serial_in"
              >
                {{ job.serial_in }}
              </table-row>

              <table-row
                label="Serial Out(Replacement)"
                v-if="job.serial_out"
                :copyText="job.serial_out"
              >
                {{ job.serial_out }}
              </table-row>

              <table-row
                label="IMEI OUT"
                v-if="job.imei_out"
                :copyText="job.imei_out"
              >
                {{ job.imei_out }}
              </table-row>

              <table-row
                label="Serial Out"
                v-if="job.serial_out"
                :copyText="job.serial_out"
              >
                {{ job.serial_out }}
              </table-row>

              <table-row icon="lni-database" :noBorder="true" />

              <table-row label="Id">
                {{ job.id }}
              </table-row>

              <table-row label="Created">
                {{
                  moment(new Date(job.created_at)).format(
                    "DD MMM YYYY, HH:mm:ss"
                  )
                }}
              </table-row>
              <table-row label="Updated">
                {{
                  moment(new Date(job.updated_at)).format(
                    "DD MMM YYYY, HH:mm:ss"
                  )
                }}
              </table-row>
            </table>
          </b-tab>

          <b-tab title="Log" class="pt-3">
            <small class="text-info font-weight-bold">JOB LOGS</small>
            <table class="table table-sm">
              <tr class="bg-dark text-white text-uppercase font-size-11">
                <td class="font-weight-bold">Date</td>
                <td class="font-weight-bold">Log</td>
                <td class="font-weight-bold text-right">User</td>
                <td></td>
              </tr>
              <tr v-for="log in job.job_logs" :key="log.id">
                <td class="font-weight-bold">
                  {{
                    moment(new Date(log.created_at)).format("DD MMM YY, HH:mm")
                  }}
                </td>
                <td>
                  {{ log.log }}
                </td>

                <td class="text-right">
                  <span v-if="log.user">
                    {{ log.user.name }}
                  </span>
                </td>
                <td class="text-right">
                  <b-avatar
                    size="sm"
                    v-if="!log.user"
                  ></b-avatar>
                  <b-avatar
                    v-if="log.user && log.user.image"
                    variant="info"
                    size="sm"
                    :src="log.user.image"
                  ></b-avatar>
                </td>
              </tr>
            </table>
            <small class="text-info font-weight-bold">JOB MOVEMENTS</small>
            <table class="table table-sm">
              <tr class="bg-dark text-white text-uppercase font-size-11">
                <td class="font-weight-bold">Date</td>
                <td class="font-weight-bold">From</td>
                <td class="font-weight-bold">To</td>
                <td class="font-weight-bold">Duration</td>
                <td class="font-weight-bold">User</td>
                <td></td>
              </tr>
              <tr v-for="movement in job.job_movements" :key="movement.id">
                <td class="font-weight-bold">
                  {{
                    moment(new Date(movement.created_at)).format(
                      "DD MMM YY, HH:mm"
                    )
                  }}
                </td>
                <td>
                  <i class="lni lni-stamp"></i> {{ movement.from.status }}<br />
                  <i class="lni lni-map-marker"></i>
                  {{ movement.from.location }}
                </td>
                <td>
                  <i class="lni lni-stamp"></i> {{ movement.to.status }}<br />
                  <i class="lni lni-map-marker"></i> {{ movement.to.location }}
                </td>
                <td>
                  {{
                    moment
                      .duration(movement.duration_seconds, "seconds")
                      .format("D [day], H [hour &] m [min]")
                  }}
                </td>
                <td class="text-right">
                  <span v-if="movement.user">
                    {{ movement.user.name }}
                  </span>
                </td>
                <td class="text-right">
                  <b-avatar
                    size="sm"
                    v-if="!movement.user"
                  ></b-avatar>
                  <b-avatar
                    v-if="movement.user && movement.user.image"
                    variant="info"
                    size="sm"
                    :src="movement.user.image"
                  ></b-avatar>
                </td>
              </tr>
            </table>
          </b-tab>

          <b-tab title="Messages">
            <span v-for="message in job.messages" :key="message.id"  class="py-2">
            <h4 class="mt-3"> {{ message.subject }}</h4> 
              <hr>
                <div
          class="p-2 mb-3 border-bottom"
          v-for="m in message.message_items"
          :key="m.id"
        >
         
            <p class="nl2br">{{ m.message }}</p>
             <v-lazy-image
              v-if="m.image"
              :src="m.image"
              class="img-fluid maxHeight500 mb-2"
            />
          
          <div class="row">
            <div class="col-auto">
              <b-avatar v-if="!m.user.image"></b-avatar>
              <b-avatar v-if="m.user.image" :src="m.user.image"></b-avatar>
            </div>
            <div class="col">
            <h6 class="mb-0 mt-1 font-weight-bold">
              {{ m.user.name }}
            </h6>
            <small class="text-muted">
              <i class="lni lni-calendar"></i>
              {{
                moment(new Date(m.created_at)).format("DD MMM YYYY, HH:mm:ss")
              }}

              |

              {{
                moment
                  .duration(
                    moment(Date.now()).diff(
                      moment(new Date(m.created_at)),
                      "seconds"
                    ),
                    "seconds"
                  )
                  .format("Y [year] D [day], H [hour &] m [min]")
              }}
              ago
            </small>
            </div>
          </div>
       

        </div>
            </span>
          </b-tab>


           <!-- <b-tab title="Comments" class="pt-3">
            <div
              v-for="comment in job.job_comments"
              :key="comment.id"
              class="card border-bottom p-2 mb-1"
            >
              <p class="nl2br">
                {{ comment.comment }}
              </p>

              <div class="row">
                <div class="col-auto">
                   <b-avatar v-if="!comment.user.image"></b-avatar>
                   <b-avatar v-if="comment.user.image" :src="comment.user.image"></b-avatar>
                </div>
                <div class="col">
                  <h6 class="mb-0 mt-1 font-weight-bold">{{ comment.user.name }}</h6>
                  <small class="text-muted">
                    <i class="lni lni-calendar"></i>
                    {{
                      moment(new Date(comment.created_at)).format(
                        "DD MMM YYYY, HH:mm:ss"
                      )
                    }}

                    |

                    {{
                      moment
                        .duration(
                          moment(Date.now()).diff(
                            moment(new Date(comment.created_at)),
                            "seconds"
                          ),
                          "seconds"
                        )
                        .format("Y [year] D [day], H [hour &] m [min]")
                    }}
                    ago
                  </small>
                </div>
              </div>
            </div>

            <form-base
              :submit-status="submitStatus"
              action="Comment"
              :errors="errors"
              :loading="loading"
              v-on:handleSubmit="createComment"
            >
              <template v-slot:fields>
                <form-group label="Comment" :required="true">
                  <textarea-autosize
                    class="form-control"
                    v-model="newComment"
                  />
                </form-group>
              </template>
            </form-base>
          </b-tab> -->

          <b-tab title="Insurance">
            <table class="table">
              <table-row label="Scheme" v-if="job.scheme_id">
                {{ job.scheme.name }}
                <small
                  v-if="job.scheme.full_cover == 1"
                  class="text-muted font-italic"
                >
                  - Full Cover</small
                >
              </table-row>

              <table-row
                label="Excess Calculation"
                v-if="job.scheme && job.scheme.full_cover == 0"
              >
                {{ job.excess_calculation_type }}
              </table-row>

              <table-row
                label="Excess Amount"
                v-if="
                  job.scheme && job.scheme.full_cover == 0 && job.excess_amount
                "
              >
                {{ job.excess_amount }}
              </table-row>

              <table-row
                label="Excess Percentage"
                v-if="
                  job.scheme &&
                  job.scheme.full_cover == 0 &&
                  job.excess_percentage
                "
              >
                {{ job.excess_percentage }} %
              </table-row>

                <table-row
                label="Replacement Price"                
              >
                {{ job.replacement_price }}
              </table-row>

              <table-row
                label="Policy Number"
                v-if="job.policy_number"
                :copyText="job.policy_number"
              >
                {{ job.policy_number }}
              </table-row>

              <table-row
                label="SPM Number"
                v-if="job.spm_number"
                :copyText="job.spm_number"
              >
                {{ job.spm_number }}
              </table-row>

              <table-row
                label="Claim Number"
                v-if="job.claim_number"
                :copyText="job.claim_number"
              >
                {{ job.claim_number }}
              </table-row>
            </table>
          </b-tab>

          <b-tab title="Client" v-if="job.client_id">
            <table class="table">
              <table-row
                label="Name"
                :noBorder="true"
                :copyText="job.client.name"
              >
                {{ job.client.name }}
              </table-row>

              <table-row label="Surname" :copyText="job.client.surname">
                {{ job.client.surname }}
              </table-row>

              <table-row label="Type">
                {{ job.client.client_type }}
              </table-row>

              <table-row label="Partner" v-if="job.client.partner">
                {{ job.client.job.partner.name }}
              </table-row>

              <table-row label="ID Number" v-if="job.client.id_number">
                {{ job.client.id_number }}
              </table-row>

              <table-row
                label="Contact Number"
                :copyText="job.client.contact_number"
              >
                {{ job.client.contact_number }}
              </table-row>

              <table-row
                label="Contact Number 2"
                v-if="job.client.contact_number_2"
              >
                {{ job.client.contact_number_2 }}
              </table-row>

              <table-row label="Email" :copyText="job.client.email_address">
                {{ job.client.email_address }}
              </table-row>

              <table-row
                label="Address"
                class="nl2br"
                :copyText="job.client.address"
                >{{ job.client.address }}</table-row
              >

              <table-row label="City" :copyText="job.client.city">
                {{ job.client.city }}
              </table-row>

              <table-row label="Postal Code" :copyText="job.client.postal_code">
                {{ job.client.postal_code }}
              </table-row>

              <table-row
                label="Province"
                v-if="job.client.province"
                :copyText="job.client.province.province"
              >
                {{ job.client.province.province }}
              </table-row>

              <table-row label="Vat #" v-if="job.client.vat_number">
                {{ job.client.vat_number }}
              </table-row>

              <table-row label="Notes">
                {{ job.client.notes }}
              </table-row>
            </table>
          </b-tab>

          <b-tab v-if="job.partner_id" title="Partner">
            <table class="table">
              <table-row label="Code">
                {{ job.partner.code }}
              </table-row>

              <table-row label="Name" :copyText="job.partner.name">
                {{ job.partner.name }}
              </table-row>

              <table-row label="Type">
                {{ job.partner.partner_type }}
              </table-row>

              <table-row
                label="Contact Number"
                :copyText="job.partner.contact_number"
              >
                {{ job.partner.contact_number }}
              </table-row>

              <table-row label="Contact Number 2">
                {{ job.partner.contact_number_2 }}
              </table-row>

              <table-row label="Email" :copyText="job.partner.email_address">
                {{ job.partner.email_address }}
              </table-row>

              <table-row
                label="Address"
                class="nl2br"
                :copyText="job.partner.address"
              >
                {{ job.partner.address }}
              </table-row>

              <table-row label="City" :copyText="job.partner.city">
                {{ job.partner.city }}
              </table-row>

              <table-row
                label="Postal Code"
                :copyText="job.partner.postal_code"
              >
                {{ job.partner.postal_code }}
              </table-row>

              <table-row
                label="Province"
                v-if="job.partner.province"
                :copyText="job.partner.province.province"
              >
                {{ job.partner.province.province }}
              </table-row>

              <table-row label="Vat #">
                {{ job.partner.vat_number }}
              </table-row>

              <table-row label="Notes" class="nl2br">
                {{ job.partner.notes }}
              </table-row>

              <table-row
                label="Schemes"
                v-if="job.partner.is_insurance_jobs == 1"
              >
                <span
                  v-for="scheme in job.partner.schemes"
                  :key="scheme.id"
                  class="d-block"
                >
                  {{ scheme.name }}
                </span>
              </table-row>
            </table>
          </b-tab>

          <b-tab title="References">
            <table class="table">
              <table-row label="POP Supplier" v-if="job.pop_supplier">
                {{ job.pop_supplier }}
              </table-row>

              <table-row label="POP Date" v-if="job.pop_date">
                {{
                  moment(new Date(job.pop_date)).format("DD MMM YYYY, HH:mm:ss")
                }}
              </table-row>

              <table-row
                label="Client"
                v-if="job.client_reference"
                :copyText="job.client_reference"
              >
                {{ job.client_reference }}
              </table-row>

              <table-row
                label="Job"
                v-if="job.job_reference"
                :copyText="job.job_reference"
              >
                {{ job.job_reference }}
              </table-row>

              <table-row
                label="Manufacture"
                v-if="job.manufacture_reference"
                :copyText="job.manufacture_reference"
              >
                {{ job.manufacture_reference }}
              </table-row>

              <table-row
                label="Secondary"
                v-if="job.secondary_reference"
                :copyText="job.secondary_reference"
              >
                {{ job.secondary_reference }}
              </table-row>
            </table>
          </b-tab>

          <b-tab title="Condition">
            <div class="p-2"></div>
            <small class="text-info font-weight-bold font-size-11"
              >CONDITION</small
            >

            <table class="table">
              <table-row label="Condition" v-if="job.condition_description">
                {{ job.condition_description }}
              </table-row>

              <table-row
                v-for="c in job.device_conditions"
                :key="c.id"
                :label="c.description"
              >
                <i class="text-success lni lni-checkmark"></i>
              </table-row>
            </table>

            <small class="text-info font-weight-bold font-size-11"
              >ACCESORIES</small
            >
            <table class="table">
              <table-row
                v-for="d in job.device_accessories"
                :key="d.id"
                :label="d.description"
              >
                <i class="text-success lni lni-checkmark"></i>
              </table-row>
            </table>

            <small class="text-info font-weight-bold font-size-11"
              >IMAGES</small
            >

            <b-skeleton-img v-if="ImageLoading"></b-skeleton-img>

            <v-lazy-image
              @intersect="ImageLoading = true"
              @load="ImageLoading = false"
              v-if="selectedImage != null"
              :src="selectedImage"
              class="img-fluid mb-2"
            />
            <div></div>

            <a
              href="#"
              @click="selectedImage = image.large"
              v-for="image in job.job_images"
              :key="image.id"
            >
              <v-lazy-image
                :src="image.small"
                class="img-fluid border mb-1 mr-1 maxHeight100 p-1"
              />
            </a>
          </b-tab>

          <b-tab title="Shipping">
            <table class="table">
              <table-row
                v-for="ship in job.job_shippings"
                :key="ship.id"
                :label="ship.leg"
                :noBorder="true"
              >
                <table class="table">
                  <table-row label="Courier">
                    {{ ship.courier.name }}
                  </table-row>
                  <table-row label="Waybill" :copyText="ship.waybill">
                    {{ ship.waybill }}
                  </table-row>
                  <table-row v-if="ship.note" label="Note">
                    {{ ship.note }}
                  </table-row>
                  <table-row
                    v-if="ship.package_code"
                    label="Package"
                    :copyText="ship.package_code"
                  >
                    {{ ship.package_code }}
                  </table-row>
                </table>
              </table-row>
            </table>
          </b-tab>

         

          <b-tab title="Reports" class="pt-3">
            <ul>
              <li>
                <a :href="clientJobCardLink" class="btn-link" target="new"
                  >Client Job Card</a
                >
              </li>
              <li>
                <a :href="quotationLink" class="btn-link" target="new"
                  >Quotation</a
                >
              </li>
              <li v-if="job.is_assessed==1">
                <a :href="damageLink" class="btn-link" target="new"
                  >Damage Report</a
                >
              </li>
              <li  v-if="job.is_repaired==1">
                <a :href="returnLetterLink" class="btn-link" target="new"
                  >Return Letter</a
                >
              </li>
              
            </ul>
            <table class="table-sm table">
                  <tr v-for="invoice in job.invoices" :key="invoice.id">
                    <td>Invoice #{{ invoice.invoice_number }}</td>
                    <td>
                      <b-badge variant="success" v-if="invoice.is_paid == 1"
                        >paid</b-badge
                      >
                      <b-badge variant="warning" v-if="invoice.is_paid == 0"
                        >unpaid</b-badge
                      >
                    </td>
                    <td>
                      {{ invoice.total_amount }}
                    </td>
                    <td>
                      <a
                        :href="
                          invoiceLink + invoice.uid + '?cid=' + job.company_id
                        "
                        class="btn-link"
                        target="new"
                      >
                        <i class="lni lni-printer text-info"></i>
                      </a>
                    </td>
                  </tr>
                </table>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import partnerJobRepo from "@/api/repos/partnerJobRepo";
import tableRow from "@/components/common/TableRow";
//import formBase from "@/components/common/FormBase";
//import formGroup from "@/components/common/FormGroup";

export default {
  props: ["id"],

  components: {
    tableRow,
    //formBase,
    //formGroup,
  },

  mounted() {
    this.getJob();
  },

  data() {
    return {
      tabIndex: 0,
      ImageLoading: false,
      selectedImage: null,
      loading: false,
      job: {},
      newComment: null,
      errors: null,
      submitStatus: null,
      clientJobCardLink: "",
      quotationLink: "",
      invoiceLink: "",
      returnLetterLink: "",
      damageLink: "",

    };
  },

  methods: {
    async getJob() {
      try {
        this.loading = true;
        let { data } = await partnerJobRepo.getDetailed(this.id);
        this.job = data.job;
        this.clientJobCardLink = `/pdf/reports/job/${this.job.uid}/client-job-card?cid=${this.job.company_id}`;
        this.damageLink = `/pdf/reports/job/${this.job.uid}/damage-report?cid=${this.job.company_id}`;
        this.returnLetterLink = `/pdf/reports/job/${this.job.uid}/return-letter?cid=${this.job.company_id}`;
        this.quotationLink = `/pdf/reports/job/${this.job.uid}/quotation?cid=${this.job.company_id}`;
        this.invoiceLink = `/pdf/reports/job/${this.job.uid}/invoice/`;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async createComment() {
      this.loading = true;
      this.submitStatus = "PENDING";

      if (this.newComment == null) {
        alert("Enter comment");
        this.submitStatus = "ERROR";
        this.loading = false;
      } else {
        try {
          await partnerJobRepo.createComment({
            comment: this.newComment,
            job_id: this.id,
          });
          this.getJob();
          this.tabIndex = 2;
          this.newComment = null;
          this;
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          } else {
            this.$root.$bvToast.toast("Something Went Wrong", {
              title: error.response.data.message,
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>
